var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgHumburgerDots = function SvgHumburgerDots(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 6,
    height: 20,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#1A2550",
    d: "M3 12.5a2.5 2.5 0 1 0 0-5 2.5 2.5 0 0 0 0 5"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#1A2550",
    d: "M3 5.5a2.5 2.5 0 1 0 0-5 2.5 2.5 0 0 0 0 5M3 19.5a2.5 2.5 0 1 0 0-5 2.5 2.5 0 0 0 0 5",
    opacity: 0.3
  })));
};
export default SvgHumburgerDots;